export class MailingAddressRequest {
    addressLine1: string;
    addressLine2?: string;
    addressLine3?: string;
    addressType?: string;
    city: { code?: string, description: string };
    country: string;
    postalCode: string;
    state: { code: string, description?: string };
    streetNumber: string | number;
}
